var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "client-empty-state d-flex flex-column align-items-center text-center mx-auto"
    },
    [
      _c(
        "div",
        {
          staticClass:
            "client-empty-state__title text-md text-color-800 text-semibold"
        },
        [_vm._v(" " + _vm._s(_vm.title) + " ")]
      ),
      _c("div", { staticClass: "text-sm text-color-900" }, [
        _vm._v(" " + _vm._s(_vm.description) + " ")
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }